export interface DomainErrorOptions {
  code: string;
}

export class DomainError extends Error {
  code?: string;

  constructor(message: string, options?: DomainErrorOptions) {
    super(message);

    this.name = this.constructor.name;
    this.code = options?.code;

    // @ts-ignore
    if (Error.captureStackTrace) {
      // @ts-ignore
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
